<template>
    <div id="exportProcess" class="content">
                <h4>{{ title }}</h4>
                <hr>
                <p>
                    <span style="color: #696969">{{ description }}</span>
                </p>
                <div class="row ">
                    <div class="col-sm-11">
                        <form>
                            <div class="form-group row">
                                <v-data-table
                                    :items="exportData"
                                    :headers="tableHeader"
                                    class="elevation-1 fixed-header"
                                >
                                    <template slot="items" slot-scope="props">
                                        <td v-for="(header, index) in tableHeader" :key="index">
                                            <span v-if="header.text === 'Date'">{{ props.item[header.value] | formatUxDate }}</span>
                                            <span v-else-if="header.text === 'Time'">{{ props.item[header.value] | formatUxTime }}</span>
                                            <span v-else-if="header.text === 'Type_In\/Out'">{{ props.item[header.value] | toggleInOut }}</span>
                                            <span v-else>{{props.item[header.value]}}</span>
                                        </td>
                                    </template>
                                </v-data-table>
                            </div>
                            <div class="form-group row text-center">
                                <div class="col-sm-11">
                                    <button type="button" class="btn btn-primary" @click.prevent="doExport">Export</button>
                                    <router-link :to="`/${$i18n.locale}/home`"><button class="btn btn-primary">CANCEL</button></router-link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

            <v-dialog v-model="dialogDownload" max-width="400px">
            <v-card>
                <v-card-title><h5>{{ title }}</h5></v-card-title>
                <v-card-text>
                    <div class="form-group">
                        The file {{ this.$store.state.exportCriteria.filename + '.' + fileType }} has been downloaded.
                    </div>

                    <div class="form-group">
                        <center>
                            <button class="btn btn-danger" @click="closeDialogDownloadHandler">CLOSE</button>
                        </center>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>

</template>

<script>
import axios from 'axios'
import moment from 'moment'
//import { compare } from 'semver';

import { toggleInOut, checkNullVal } from '../common/toggle.js'

export default {
    data() {
        props: []
        return {
            title: 'Clock Data Export',
            description: 'Table below lists records exported prior this, please confirm to continue export or abort process',
            tableHeader: [],
            exportData: [],
            downloadData: [],
            templateHeader: [],
            templateDetail: [],
            status: '',
            dialogDownload: false,
            fileType: null,
        }
    },

    computed: {
        exportCriteria() {
            return this.$store.state.exportCriteria
        }
    },

    methods: {

        // TODO: API to get all fields from table template where sequence != null and return result.
        // Client will array should only receive the columns where sequence != null.

        closeDialogDownloadHandler() {
          this.dialogDownload = false;
        },

        retriveTableHeader() {
            let vm = this
            let template_id = this.$store.state.exportCriteria.template_id

            axios.get(this.$store.getters.rootAPI + '/export/template/' + template_id)
            .then(function (response) {

                vm.tableHeader = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveData() {
            let vm = this
            let template_id = this.$store.state.exportCriteria.template_id
            let start_date = this.$store.state.exportCriteria.start_date
            let end_date = this.$store.state.exportCriteria.end_date
            let project_id = this.$store.state.exportCriteria.project_id
            let reason_id = this.$store.state.exportCriteria.reason_id
            let company_id = this.$store.state.exportCriteria.company_id
            let geolocation_id = this.$store.state.exportCriteria.geolocation_id

            axios.post(this.$store.getters.rootAPI + '/export/verify/' + template_id, {
                start_date: start_date,
                end_date: end_date,
                fil_project: project_id,
                fil_reason: reason_id,
                fil_company: company_id,
                fil_geolocation: geolocation_id
             
            })
            .then(function (response) {
                vm.exportData = response.data.rec;
    
                let headers = Object.keys(vm.exportData[0])

                for (let t = 0; t < headers.length; t++) {
                    vm.tableHeader.push({text: headers[t], value: headers[t]})
                }

            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveTemplateHeader(){
            let vm = this
            let template_id = this.$store.state.exportCriteria.template_id

            axios.get(this.$store.getters.rootAPI + '/export/template_header/' + template_id)
            .then(function (response) {
                vm.templateHeader = response.data.rec;
                vm.fileType = vm.templateHeader[0].filetype
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveTemplateDetail(){
            let vm = this
            let template_id = this.$store.state.exportCriteria.template_id

            axios.get(this.$store.getters.rootAPI + '/export/template_detail/' + template_id)
            .then(function (response) {
                vm.templateDetail = response.data.rec;
                //console.log(vm.templateDetail)
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveExportData(){
            let vm = this
            let template_id = this.$store.state.exportCriteria.template_id
            let start_date = this.$store.state.exportCriteria.start_date
            let end_date = this.$store.state.exportCriteria.end_date
            let project_id = this.$store.state.exportCriteria.project_id
            let reason_id = this.$store.state.exportCriteria.reason_id
            let company_id = this.$store.state.exportCriteria.company_id
            let geolocation_id = this.$store.state.exportCriteria.geolocation_id

            axios.post(this.$store.getters.rootAPI + '/export/data/' + template_id, {
                start_date: start_date,
                end_date: end_date,
                fil_project: project_id,
                fil_reason: reason_id,
                fil_company: company_id,
                fil_geolocation: geolocation_id
            })
            .then(function (response) {
                vm.downloadData = response.data.rec;
                /*
                for (let i = 0; i < vm.downloadData.length; i++) {

                    if (!vm.downloadData[i].ID || typeof undefined) {
                        vm.downloadData[i].ID = ''
                    }

                    if (!vm.downloadData[i].Device || typeof undefined) {
                        vm.downloadData[i].Device = ''
                    }

                }
                */
                vm.getCSV() ;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        objectToCSV(data) {
            const csvRows = []

            // get header
            const headers = Object.keys(data[0])
            let newArray = headers.map(value => value === 'DeviceTime' || value === 'SystemTime' ? 'Time' : value);
            csvRows.push(newArray.join(this.templateHeader[0].delimeter))

            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')

                    return `${escaped}`
                    //return `"${escaped}"`
                });

                csvRows.push(values.join(this.templateHeader[0].delimeter))

            }
            return csvRows.join('\n')
        },

        download(data) {
            const blob = new Blob([data], { type: 'text/' + this.templateHeader[0].filetype})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download', this.$store.state.exportCriteria.filename + '.' + this.templateHeader[0].filetype)

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)

            this.dialogDownload = true;
        },

        async getCSV() {
            let item = this.downloadData

            for (var i = 0; i < item.length; i++) {
                if (item[i].Date) {
                    for (let f = 0; f < this.templateDetail.length; f++) {
                        if (this.templateDetail[f].row_no === 3) {
                            let dateFormat = this.templateDetail[f].type_format

                            this.downloadData[i].Date = moment.unix(item[i].Date).format(dateFormat)
                        }
                    }
                }

                if (item[i].Time) {
                    for (let f = 0; f < this.templateDetail.length; f++) {
                        if (this.templateDetail[f].row_no === 4) {
                            let timeFormat = this.templateDetail[f].type_format

                            this.downloadData[i].Time = moment.unix(item[i].Time).format(timeFormat)
                        }
                    }
                }

                if (item[i].TypeInOut) {

                    var inOutValue = this.downloadData[i].TypeInOut;

                    for (let f = 0; f < this.templateDetail.length; f++) {
                        if (this.templateDetail[f].row_no === 5) {

                            // check if user has specified custom IN OUT indicator. If true, use
                            // custom indicator, else use default
                            if (this.templateDetail[f].in_out_inc !== null | typeof undefined) {
                                var indicatorValue = this.templateDetail[f].in_out_inc;
                                var indicatorArr = indicatorValue.split(',');

                                if (inOutValue == 1) {
                                    this.downloadData[i].TypeInOut = indicatorArr[0];
                                } else {
                                    this.downloadData[i].TypeInOut = indicatorArr[1];
                                }
                            } else {
                                this.downloadData[i].TypeInOut = toggleInOut(item[i].TypeInOut)
                            }
                        }
                    }
                }
            }

            const csvData = this.objectToCSV(this.downloadData)

            this.download(csvData)
        },

        doExport() {
            this.retriveExportData();
        }
    },

    created() {
        this.retriveData();
        this.retriveTemplateHeader();
        this.retriveTemplateDetail();
    }
}
</script>

<style lang="stylus">
@import '~vuetify-stylus-fixed-table-header';

.fixed-header {
  fixed-table-header(35vh)
}
</style>



// WEBPACK FOOTER //
// src/components/export/ExportProcess.vue